import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DownloadArtifactLoader, getDownloadArtifactAuthDetails, getPhotoCaptureQuestionnaireId, getPhotoCaptureWorkItemStatus, photoCaptureIntelligentGetDownloadAuthDetailsDataAction } from "../../../domain/photoCapture";
import { getGPCEvaluationDocId } from '../utilities';
const mapStateToProps = (state) => {
    return {
        workItemStatus: getPhotoCaptureWorkItemStatus(state),
        evaluationDocId: getGPCEvaluationDocId(state),
        questionnaireId: getPhotoCaptureQuestionnaireId(state),
        downloadArtifactAuthDetailsInfo: getDownloadArtifactAuthDetails(state)
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        photoCaptureIntelligentGetDownloadAuthDetailsDataAction
    }, dispatch);
};
export const ConnectedDownloadArtifactLoader = connect(mapStateToProps, mapDispatchToProps)(DownloadArtifactLoader);
//# sourceMappingURL=ConnectedDownloadArtifactLoader.js.map